import BillingService from "../../services/Billing"
import ServiceCaller from "../../services/ServiceCaller"
import StripeUtils from "../../utils/StripeUtils";
const service = new BillingService()

const state = {
  error: "",
  inProgress: false,
  getBillingResponse: null,
  saveBillingResponse: null,
  removeBillingResponse: null,
  subscribeResponse: null,
  disableAutoRenewResponse: null,
  enableAutoRenewResponse: null,
  cancelSubscribtionResponse: null,
  addCardResponse: null,

  subscribeResult: null,
  subscribePISecret: null,

}

const mutations = {
  setError: (state, value) => state.error = value,
  setInProgress: (state, value) => state.inProgress = value,
  setGetBillingResponse: (state, value) => state.getBillingResponse = value,
  setSaveBillingResponse: (state, value) => state.saveBillingResponse = value,
  setRemoveBillingResponse: (state, value) => state.removeBillingResponse = value,
  setSubscribeResponse: (state, value) => state.subscribeResponse = value,
  setDisableAutoRenewResponse: (state, value) => state.disableAutoRenewResponse = value,
  setEnableAutoRenewResponse: (state, value) => state.enableAutoRenewResponse = value,
  setCancelSubscriptionResponse: (state, value) => state.cancelSubscribtionResponse = value,
  setAddCardResponse: (state, value) => state.addCardResponse = value,
}

const getters = {}

const actions = {
  getBilling: (context) => ServiceCaller.call(service.getBilling(), context.commit, 'setGetBillingResponse', 'setError', 'setInProgress', false),
  saveBilling: (context, billingInfo) => ServiceCaller.call(service.saveBilling(billingInfo), context.commit, 'setSaveBillingResponse', 'setError', 'setInProgress', true),
  removeBilling: (context) => ServiceCaller.call(service.removeBilling(), context.commit, 'setRemoveBillingResponse', 'setError', 'setInProgress', true),
  cancelSubscription: (context, payload) => ServiceCaller.call(service.cancelSubscribtion(payload), context.commit, 'setCancelSubscriptionResponse', 'setError', 'setInProgress', true),
  disableAutoRenew: (context, payload) => ServiceCaller.call(service.disableAutoRenew(payload), context.commit, 'setDisableAutoRenewResponse', 'setError', 'setInProgress', true),
  enableAutoRenew: (context, payload) => ServiceCaller.call(service.enableAutoRenew(payload), context.commit, 'setEnableAutoRenewResponse', 'setError', 'setInProgress', true),
  addCard: (context, token) => ServiceCaller.call(service.addCard(token), context.commit, 'setAddCardResponse', 'setError', 'setInProgress', true),
  subscribe: async (context, payload) => {
    try {
      context.commit('setInProgress', true)
      context.state.subscribeResult = null
      context.state.subscribePISecret = null
      let response = await service.subscribe(payload)
      let data = ServiceCaller.parseData(response)
      context.commit('setSubscribeResponse', data)
      // Get results
      context.state.subscribeResult = StripeUtils.getSubscribtionResult(data)
      context.state.subscribePISecret = data.PISecret
      context.commit('setInProgress', false)

    } catch (err) {
      context.commit('setInProgress', false)
      context.commit('setError', ServiceCaller.parseError(err))
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


